/* ─── BAZA theme.js ───────────────────────────────────────────────────────
   JS vanilla, sin dependencias. Maneja:
   - Hero slider (autoplay + dots + Ken Burns)
   - Reveal on scroll (.fade-in -> .visible)
   - Nav scrolled state
   - Announcement bar close
   - Cart drawer (open/close + add to cart vía fetch a /cart/add.js)
*/
(function () {
  "use strict";

  /* ── iOS scroll lock helper ──────────────────────────────────────────
     Bug fix runtime audit: `body { overflow: hidden }` NO bloquea scroll
     en iOS Safari mobile (bug WebKit conocido). El usuario tocaba el
     backdrop / area no-scrollable del overlay y la pagina detras
     scrolleaba, ademas perdia el scroll position al cerrar.

     Patron correcto: position:fixed + top:-scrollY + restaurar scroll
     en unlock. Centralizado en window.BAZA.scrollLock.

     Counter mantiene tracking de overlays apilados (cart + search abiertos
     simultaneamente). */
  var lockCount = 0;
  var savedY = 0;
  function lock() {
    if (lockCount === 0) {
      savedY = window.scrollY || window.pageYOffset || 0;
      var b = document.body;
      b.style.position = 'fixed';
      b.style.top = '-' + savedY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    }
    lockCount++;
  }
  function unlock() {
    if (lockCount <= 0) return;
    lockCount--;
    if (lockCount === 0) {
      var b = document.body;
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      // tokens.css define `html { scroll-behavior: smooth }` global, lo que hacia
      // que este scrollTo se ANIMARA al cerrar overlays (mobile menu, cart, search):
      // la pagina "saltaba" al top y volvia con efecto. Forzamos scroll instantaneo
      // via estilo inline (gana sobre el CSS) y restauramos el valor previo.
      var de = document.documentElement;
      var prevSB = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      window.scrollTo(0, savedY);
      de.style.scrollBehavior = prevSB;
    }
  }
  window.BAZA = window.BAZA || {};
  window.BAZA.scrollLock = { lock: lock, unlock: unlock };

  /* ── Hero slider: gestionado por hero.liquid (section-scoped) ───────── */
  /* Removido bloque legacy v1 que peleaba con hero.liquid:466-570
     (doble timer, doble handler en dots, estados desincronizados). */

  /* ── Reveal on scroll ────────────────────────────────────────────────── */
  /* QA fix 2026-06-01: safety timeout 2.5s para forzar .visible si IO no
     dispara (race condition, threshold no se cumple antes que usuario scrollee
     o sale del viewport). Antes: elementos quedaban invisibles permanentemente. */
  const reveals = document.querySelectorAll(".fade-in");
  if (reveals.length && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((el) => io.observe(el));
    setTimeout(() => {
      reveals.forEach((el) => { if (!el.classList.contains("visible")) el.classList.add("visible"); });
    }, 2500);
  } else {
    reveals.forEach((el) => el.classList.add("visible"));
  }

  /* ── Nav scrolled state: gestionado por header.liquid (mismo nav) ───── */
  /* Removido bloque duplicado v1 (threshold 8px conflictaba con el de
     header.liquid:308-323 que usa 4px + integra scroll progress bar). */

  /* ── Announcement bar close ──────────────────────────────────────────── */
  const announcement = document.querySelector("[data-announcement]");
  const announcementClose = document.querySelector("[data-announcement-close]");
  if (announcement && announcementClose) {
    announcementClose.addEventListener("click", () => {
      announcement.classList.add("hidden");
      document.body.classList.add("no-announcement");
    });
  }

  /* ── Menú mobile: gestionado por header.liquid (mismo selector) ──────── */
  /* Removido bloque duplicado v1 — binding doble en [data-hamburger] +
     [data-menu-close]. header.liquid:299-313 owna apertura, cierre, body
     scroll lock y aria-hidden. ESC handler agregado abajo. */

  /* ── Toast de marca (reemplaza el alert nativo): no bloquea, se autodescarta ── */
  function showToast(msg) {
    var t = document.createElement("div");
    t.setAttribute("role", "status");
    t.textContent = msg;
    t.style.cssText = "position:fixed;left:50%;bottom:24px;transform:translateX(-50%) translateY(12px);z-index:var(--z-toast,600);background:var(--bordo,#7A2A2A);color:var(--paper,#fff);font-family:var(--font-mono,ui-monospace,monospace);font-size:12px;letter-spacing:0.04em;padding:14px 22px;box-shadow:0 10px 30px rgba(5,5,5,0.25);opacity:0;transition:opacity .3s ease,transform .3s cubic-bezier(0.16,1,0.3,1);max-width:88vw;text-align:center;";
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.style.opacity = "1"; t.style.transform = "translateX(-50%) translateY(0)"; });
    setTimeout(function () {
      t.style.opacity = "0"; t.style.transform = "translateX(-50%) translateY(12px)";
      setTimeout(function () { t.remove(); }, 350);
    }, 4000);
  }

  /* ── Add to cart: delega UI a cart-drawer.liquid via window.BAZA.cart API ── */
  document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : "";
      if (btn) { btn.textContent = "..."; btn.disabled = true; }
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || "add failed");
        }
        if (window.BAZA && window.BAZA.cart) {
          await window.BAZA.cart.refresh();
          window.BAZA.cart.open();
          // QA polish: cart icon bump anim cuando se agrega item — tactile feedback
          var cartBtn = document.querySelector('[data-cart-trigger]');
          if (cartBtn) {
            cartBtn.classList.remove('is-bumped');
            // Force reflow para reiniciar animacion
            void cartBtn.offsetWidth;
            cartBtn.classList.add('is-bumped');
            setTimeout(function() { cartBtn.classList.remove('is-bumped'); }, 500);
          }
        } else {
          window.location.href = "/cart";
        }
      } catch (err) {
        console.error("add to cart failed", err);
        showToast("No pudimos agregar el producto. Intentá de nuevo.");
      } finally {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      }
    });
  });
})();
